<div class="du-chat-contact-list-container">
    <!-- Header -->
    <app-chat-header [userflag]="userflag" [currentUser]="userDetails" (arrowBack)="arrowBack($event)"></app-chat-header>

    <!-- User List -->
    <div *ngIf="!userflag">
        <app-chat-user-list (selectedUser)="selectedUser($event)"></app-chat-user-list>
    </div>

    <!-- Individual chart room -->
    <div *ngIf="userflag">
        <app-chatroom-window [userDetails]="this.userDetails"></app-chatroom-window>
    </div>
</div>